import React, { useCallback } from 'react';
import { Select } from 'antd';
import { useFieldController } from '../../../../../helpers/formManager';
import Field from '../../../shared/ui/Field';
import { declOfNum } from '../../../../../helpers/dspx-utils';
import { useValueRef } from '../../../../../hooks/useValueRef';

const SelectAcceptanceDuration = ({
  name,
  label,
  changeCb,
  durations,
  placeholder,
  disabled,
}) => {
  const changeCbRef = useValueRef(changeCb);

  const {
    field: { value, onChange },
    fieldState,
  } = useFieldController({
    name,
    rules: { required: 'Укажите продолжительность приемки' },
  });

  const handleChange = useCallback(
    (value) => {
      onChange(value);

      if (typeof changeCbRef.current === 'function') {
        changeCbRef.current(value);
      }
    },
    [onChange, changeCbRef]
  );

  return (
    <Field.Memoized
      type={Field.types.select}
      value={value}
      onChange={handleChange}
      errorMessage={fieldState.error?.message}
      formItemLabel={label}
      required
      style={{ width: '100%' }}
      placeholder={placeholder}
      disabled={disabled}
    >
      {durations?.map((option) => (
        <Select.Option key={option} value={option}>
          {formatDuration(option)}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
};

export default SelectAcceptanceDuration;

function formatDuration(minutes) {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  if (h > 0 && m > 0) {
    return `${formatHours(h)} ${formatMinutes(m)}`;
  }

  if (h > 0) {
    return `${formatHours(h)}`;
  }

  return `${formatMinutes(m)}`;
}

function formatMinutes(m) {
  return `${m} ${declOfNum(m, ['минута', 'минуты', 'минут'])}`;
}

function formatHours(h) {
  return `${h} ${declOfNum(h, ['час', 'часа', 'часов'])}`;
}
